// Access control: only users from these domains can access Customer data.
// Everyone else (outside these domains) sees the Price List only.
export const CUSTOMER_DATA_ALLOWED_DOMAINS = [
  "gmail.com",
  "usaircompressor.com",
  "aircompressorcanada.com",
];

export function canAccessCustomers(user) {
  if (!user) return false;
  // Customer-role users can view their own company data.
  if (user.role === "customer") return true;
  if (!user.email) return false;
  const email = String(user.email).toLowerCase().trim();
  const at = email.lastIndexOf("@");
  if (at === -1) return false;
  const domain = email.slice(at + 1);
  return CUSTOMER_DATA_ALLOWED_DOMAINS.includes(domain);
}
